import { IStore } from 'redux/IStore';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
import { browserHistory } from 'react-router';
import { IPage } from 'models/common';
import { IMenuItemDataAction, IMenuItemData, IMenuItem } from 'models/menuitem/menuitem';
import { MenuItemType } from 'models/enums/menuitemtype';
import * as c from 'models/constants';
const { notifSend } = notifActions;

/** Action Types */
export const REQUEST_START: string = 'menuitem/REQUEST_START';
export const GET_SUCCESS: string = 'menuitem/GET_SUCCESS';
export const REQUEST_FAILURE: string = 'menuitem/REQUEST_FAILURE';
export const ADD_SECTION: string = 'menuitem/ADD_SECTION';
export const SET_IS_EDIT: string = 'menuitem/SET_IS_EDIT';
export const SET_PAGE: string = 'menuitem/SET_PAGE';
export const RESET_DATA: string = 'menuitem/RESET_DATA';
export const SET_ISFIRSTLOAD: string = 'menuitem/SET_ISFIRSTLOAD';
export const SET_ITEMS_PAGE: string = 'menuitem/SET_ITEMS_PAGE';
export const SET_ACTIVE_MENUITEM_ID: string = 'menuitem/SET_ACTIVE_MENUITEM_ID';

const maxDate = new Date(new Date().getFullYear() + 5, 0, 1);

const ITEMSPERPAGE = 10;

/** Initial State */
const initialState: IMenuItemData = {
	isFetching: false,
	items: [],
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: ITEMSPERPAGE,
		items: [],
	},
	isFirstLoad: false,
	menuItem: {
		releaseDate: new Date(),
		expireDate: maxDate,
	},
	isEdit: false,
	activeMenuItemId: '',
};

/** Reducer */
export function menuItemReducer(state = initialState, action: IMenuItemDataAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
				friendlyUrlAreadyExists: false,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				menuItem: action.payload.menuItem,
				page: action.payload.menuItem.pageJObject,
				error: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
				friendlyUrlAreadyExists: false,
			});

		case SET_IS_EDIT:
			return Object.assign({}, state, {
				isEdit: action.payload.isEdit,
			});

		case SET_PAGE:
			return Object.assign({}, state, {
				menuItem: {
					...state.menuItem,
					page: action.payload.pageString,
				},
				isFetching: false,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: ITEMSPERPAGE,
					items: [],
				},
			});

		case SET_ISFIRSTLOAD:
			return Object.assign({}, state, {
				isFirstLoad: action.payload.isFirstLoad,
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case SET_ACTIVE_MENUITEM_ID:
			return Object.assign({}, state, {
				activeMenuItemId: action.payload.activeMenuItemId,
			});

		default:
			return state;
	}
}

/** Async Action Creator */
export function getMenuItemData(code: string) {
	return (dispatch, getState: () => IStore) => {
		if (code) {
			dispatch(requestStart());
			return fetch(
				getState().fetchDefault.baseAPI + 'api/MenuItem/GetMenuItem/' + code,
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => {
							dispatch(getMenuItemSuccess(res));
							dispatch(setIsEdit(true));
						});
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(requestFailure(err));
				});
		} else {
			const menuItem: IMenuItem = {
				releaseDate: new Date(),
				expireDate: maxDate,
				pageJObject: {
					menuType: c.MENU_TYPE_PAGE,
					sections: [],
				},
			};
			dispatch(getMenuItemSuccess(menuItem));
			dispatch(setIsEdit(false));
		}
	};
}

/** Async Action Creator */
export function getMagazineHomePageData(culture: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		return fetch(
			getState().fetchDefault.baseAPI + 'api/MenuItem/Magazine/Home/' + culture,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(getMenuItemSuccess(res));
						dispatch(setIsEdit(false));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Async Action Creator */
export function getPortalHomePageData(culture: string, isFirstLoad: boolean, code: string) {
	return (dispatch, getState: () => IStore): Promise<any> => {
		//home page api is not paged in reality is one json just page on client side sections because of lazy loading section images on Home
		if (isFirstLoad) {
			dispatch(resetHomePageData());
			dispatch(setHomePageIsFirstLoad(false));
		}
		dispatch(requestStart());
		const currentPage: number = getState().menuItem.itemsPage.currentPage;
		const itemsPerPage: number = getState().menuItem.itemsPage.itemsPerPage;
		if (isFirstLoad) {
			let url: string = '';
			if (culture) {
				url = 'api/MenuItem/Portal/Home/' + culture;
			} else if (code) {
				url = 'api/MenuItem/GetMenuItem/' + code;
			}

			return fetch(getState().fetchDefault.baseAPI + url, Object.assign({}, getState().fetchDefault.requestInit))
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => {
							res.pageJObject = JSON.parse(res.page);
							const homePageState: IMenuItemData = getState().menuItem;
							const items: any[] = homePageState.items;
							if (res.pageJObject && res.pageJObject.sections) {
								const newItems: any[] = res.pageJObject.sections.slice(
									currentPage * itemsPerPage,
									currentPage * itemsPerPage + itemsPerPage,
								);
								Array.prototype.push.apply(items, newItems);
							} else {
								homePageState.items = [];
							}
							dispatch(getMenuItemSuccess(res));
							const itemsPage: IPage = {
								currentPage: currentPage + 1,
								totalPages:
									res.pageJObject && res.pageJObject.sections
										? Math.ceil(res.pageJObject.sections.length / ITEMSPERPAGE)
										: 0,
								totalItems: res.pageJObject && res.pageJObject.sections ? res.pageJObject.sections.length : 0,
								itemsPerPage: ITEMSPERPAGE,
								items,
							};
							dispatch(setHomePagePage(itemsPage));
						});
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(requestFailure(err));
				});
		} else {
			const homePageState: IMenuItemData = getState().menuItem;
			const items: any[] = homePageState.items;
			const newItems: any[] = homePageState.menuItem.pageJObject.sections.slice(
				currentPage * itemsPerPage,
				currentPage * itemsPerPage + itemsPerPage,
			);
			Array.prototype.push.apply(items, newItems);
			const itemsPage: IPage = {
				currentPage: currentPage + 1,
				totalPages: Math.ceil(homePageState.menuItem.pageJObject.sections.length / ITEMSPERPAGE),
				totalItems: homePageState.menuItem.pageJObject.sections.length,
				itemsPerPage: ITEMSPERPAGE,
				items,
			};
			dispatch(setHomePagePage(itemsPage));
			dispatch(getMenuItemSuccess(homePageState.menuItem));
		}
	};
}

/** Action Creator - update */
export function saveMenuItem(menuItem: IMenuItem, menuItemType: MenuItemType) {
	return (dispatch, getState: () => IStore) => {
		let url: string = getState().fetchDefault.baseAPI + 'api/MenuItem/';

		if (menuItemType === MenuItemType.Portal) {
			url = url + 'Portal/';
		} else if (menuItemType === MenuItemType.Magazine) {
			url = url + 'Magazine/';
		}

		url = url + menuItem.id;

		dispatch(requestStart());

		const page: any = getState().menuItem.page;
		page.menuType = c.MENU_TYPE_PAGE;
		menuItem.page = JSON.stringify(page);

		return fetch(
			url,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(menuItem),
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(getMenuItemSuccess(menuItem));
					dispatch(
						notifSend({ message: i18n.t('Notification_Success_Page_Saved'), kind: 'success', dismissAfter: 3000 }),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(getMenuItemSuccess(menuItem));
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator - create */
export function addMenuItem(menuItem: IMenuItem, menuItemType: MenuItemType) {
	return (dispatch, getState: () => IStore) => {
		let url: string = getState().fetchDefault.baseAPI + 'api/MenuItem/';
		let editPageUrl = '';

		if (menuItemType === MenuItemType.Portal) {
			url = url + 'Portal';
			editPageUrl = '/admin/portal/pages/edit/';
		} else if (menuItemType === MenuItemType.Magazine) {
			url = url + 'Magazine';
			editPageUrl = '/admin/magazine/pages/edit/';
		}

		dispatch(requestStart());

		const page: any = getState().menuItem.page;
		page.menuType = c.MENU_TYPE_PAGE;
		menuItem.page = JSON.stringify(page);

		return fetch(
			url,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(menuItem),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((newMenuItem: IMenuItem) => {
						dispatch(getMenuItemSuccess(newMenuItem));
						browserHistory.push(editPageUrl + newMenuItem.code);

						dispatch(
							notifSend({
								message: i18n.t('Notification_Success_MenuItem_Created'),
								kind: 'success',
								dismissAfter: 3000,
							}),
						);
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(getMenuItemSuccess(menuItem));
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator - update */
export function saveSection(section: any) {
	return (dispatch, getState: () => IStore) => {
		const page: any = getState().menuItem.page;
		page.sections.unshift(section);

		dispatch(setPage(JSON.stringify(page)));
		dispatch(notifSend({ message: i18n.t('Notification_Success_Section_Added'), kind: 'success', dismissAfter: 3000 }));
	};
}

export function editSection(section: any, index: number) {
	return (dispatch, getState: () => IStore) => {
		const page: any = getState().menuItem.page;
		page.sections[index] = section;

		dispatch(setPage(JSON.stringify(page)));
		dispatch(
			notifSend({ message: i18n.t('Notification_Success_Section_Updated'), kind: 'success', dismissAfter: 3000 }),
		);
	};
}

export function removeSection(index: number) {
	return (dispatch, getState: () => IStore) => {
		const page: any = getState().menuItem.page;
		page.sections.splice(index, 1);

		dispatch(setPage(JSON.stringify(page)));
		dispatch(
			notifSend({ message: i18n.t('Notification_Success_Section_Deleted'), kind: 'success', dismissAfter: 3000 }),
		);
	};
}

/** Action Creator */
export function updateSectionsOrder(sections: any[]) {
	return (dispatch, getState: () => IStore) => {
		const page: any = getState().menuItem.page;
		page.sections = sections;

		dispatch(setPage(JSON.stringify(page)));
	};
}

/** Action Creator */
export function requestStart(): IMenuItemDataAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getMenuItemSuccess(menuItem: IMenuItem): IMenuItemDataAction {
	if (menuItem.page && menuItem.page.length > 0) {
		menuItem.pageJObject = JSON.parse(menuItem.page);
	}

	if (!menuItem.pageJObject) {
		menuItem.pageJObject = {
			menuType: c.MENU_TYPE_PAGE,
			sections: [],
		};
	}

	if (!menuItem.pageJObject.menuType) {
		menuItem.pageJObject.menuType = c.MENU_TYPE_PAGE;
	}

	if (!menuItem.pageJObject.sections) {
		menuItem.pageJObject.sections = [];
	}

	return {
		type: GET_SUCCESS,
		payload: {
			menuItem,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IMenuItemDataAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setIsEdit(isEdit: boolean): IMenuItemDataAction {
	return {
		type: SET_IS_EDIT,
		payload: {
			isEdit,
		},
	};
}

/** Action Creator */
export function setPage(pageString: string): IMenuItemDataAction {
	return {
		type: SET_PAGE,
		payload: {
			pageString,
		},
	};
}

/** Action Creator */
export function resetHomePageData(): IMenuItemDataAction {
	return {
		type: RESET_DATA,
	};
}

export function setHomePageIsFirstLoad(isFirstLoad: boolean): IMenuItemDataAction {
	return {
		type: SET_ISFIRSTLOAD,
		payload: {
			isFirstLoad,
		},
	};
}

export function setHomePagePage(itemsPage: IPage): IMenuItemDataAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

export function setActiveMenuItemId(activeMenuItemId: string): IMenuItemDataAction {
	return {
		type: SET_ACTIVE_MENUITEM_ID,
		payload: {
			activeMenuItemId,
		},
	};
}
